import { render, staticRenderFns } from "./pBar.vue?vue&type=template&id=9f7ae0ce&scoped=true&"
import script from "./pBar.vue?vue&type=script&lang=js&"
export * from "./pBar.vue?vue&type=script&lang=js&"
import style0 from "./pBar.vue?vue&type=style&index=0&id=9f7ae0ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7ae0ce",
  null
  
)

export default component.exports